package com.flowyride.core.domain.usecase

import com.flowyride.core.domain.speedcamera.SpeedCamera
import com.flowyride.core.domain.speedcamera.SpeedCameraRepository
import com.flowyride.core.domain.util.suspendRunCatching

class GetSpeedCamerasUseCase(private val repository: SpeedCameraRepository) {
    suspend operator fun invoke(): Result<List<SpeedCamera>> = suspendRunCatching { repository.all() }
}
